<div class="pageheader">
    <div class="page-title">
        <h1>XML Property Promotions</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'XML Property Promotions log'">
                <app-change-log-link-entity type="PromotedPropertyFilter"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='xmlPropertyPromotionFilters' [bizSetColumnChooser]="true"
    [bizSetAllowColumnReordering]="false" [bizSetSearchPanel]="false" [bizSetPager]="false"
    (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)"
    (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)"
    [masterDetail]="{ enabled: true, template: 'properties' }" [bizEditRowOnDoubleClick]="true">

    <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding"
        [allowDeleting]="allowDeleting">
        <dxo-popup title="XML Promotion Identification" [showTitle]="true"></dxo-popup>

        <dxo-form>
            <dxi-item dataField="Description" [colSpan]="2"></dxi-item>
            <dxi-item caption="XML Root Node" itemType="group" [colCount]="2" [colSpan]="2">
                <dxi-item dataField="RootNode"></dxi-item>
                <dxi-item dataField="RootNamespace"></dxi-item>
            </dxi-item>

            <dxi-item caption="Optional Field Match" itemType="group" [colCount]="2" [colSpan]="2">
                <dxi-item dataField="XpathField"></dxi-item>
                <dxi-item dataField="XpathValue"></dxi-item>
            </dxi-item>
        </dxo-form>
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="Description" caption="XML Promotion Description" dataType="string" [allowFiltering]="false"
        [allowGrouping]="false">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="RootNode" caption="Root Node" dataType="string" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="RootNamespace" caption="Root Node Namespace" dataType="string"></dxi-column>

    <dxi-column dataField="XpathField" caption="Xpath to Field" dataType="string" editCellTemplate="editXPathFieldTemplate">
    </dxi-column>

    <dxi-column dataField="XpathValue" caption="Value of Field" dataType="string">
    </dxi-column>

    <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(xmlPropertyPromotionFilters, 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(xmlPropertyPromotionFilters, 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log"
                    template="logTemplate"
                    [visible]="allowShowLog">
        </dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Description" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="PromotedPropertyFilter" [id]="cell.data.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>

    <ng-container *dxTemplate="let cell of 'editXPathFieldTemplate'">
        <app-xpath caption="-o-" [value]="cell.value" (valueChange)="onXPathFieldValueChange($event, cell)"></app-xpath>
    </ng-container>

    <ng-container *dxTemplate="let cellInfo of 'properties'">
        <div style="border: 1px solid #ddd; border-radius: 5px; padding: 1em; background-color: white;">
            <label>Promoted Properties</label>
            <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='cellInfo.data.Fields'
                [bizSetColumnChooser]="true" [bizSetAllowColumnReordering]="false"
                [bizHideSelectedRowsComponent]="true" [showResetButton]="false" [bizSetGroupPanel]="false"
                [bizSetPager]="false" [bizSetSearchPanel]="false"
                (onInitNewRow)="onPropertyFieldInitNewRow($event, cellInfo.data)"
                (onRowInserting)="onPropertyFieldRowInserting($event)"
                (onRowUpdating)="onPropertyFieldRowUpdating($event)" (onRowRemoving)="onPropertyFieldRowRemoving($event)" (onEditorPreparing)="onEditorPreparing($event)" (onEditingStart)="onEditingStart($event)">

                <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
                    <dxo-popup title="Property promotion" [showTitle]="true"></dxo-popup>

                    <dxo-form>
                        <dxi-item caption="Predefined System Properties" itemType="group" [colCount]="2" [colSpan]="2">
                            <dxi-item dataField="Property" [colSpan]="2"></dxi-item>
                        </dxi-item>
                        <dxi-item caption="Property Details" itemType="group" [colCount]="2" [colSpan]="2">
                            <dxi-item dataField="PropertyName" [editorOptions]="{ disabled: isSystemProperty }"></dxi-item>
                            <dxi-item dataField="PropertyNamespace" [editorOptions]="{ disabled: isSystemProperty }"></dxi-item>
                            <dxi-item dataField="Xpath"></dxi-item>
                            <dxi-item dataField="PropertyDefaultValue"></dxi-item>
                        </dxi-item>
                    </dxo-form>
                </dxo-editing>

                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                <dxi-column dataField="Property" caption="System Property" dataType="string" [visible]="false"
                    [setCellValue]="setCellValue" [editorOptions]="{ showClearButton: false }">
                    <dxo-lookup [dataSource]="systemProperties" valueExpr="Name" displayExpr="Name">
                    </dxo-lookup>
                </dxi-column>

                <dxi-column dataField="PropertyName" caption="Property Name" dataType="string" sortOrder="asc"
                    [allowGrouping]="false" [allowFiltering]="false" [allowSorting]="false">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="PropertyNamespace" caption="Property Namespace" dataType="string"
                    [allowGrouping]="false" [allowFiltering]="false" [allowSorting]="false">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="Xpath" caption="Xpath to Property Value" dataType="string"
                    [allowGrouping]="false" [allowFiltering]="false" [allowSorting]="false"
                    editCellTemplate="editXPathPropTemplate">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="PropertyDefaultValue" caption="Default Value" dataType="string"
                    [allowGrouping]="false" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>

                <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"></dxi-column>
                <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
                <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false"></dxi-column>
                <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

                <ng-container *dxTemplate="let cell of 'editXPathPropTemplate'">
                    <app-xpath caption="-o-" [value]="cell.value" (valueChange)="onXPathPropValueChange($event, cell)"></app-xpath>
                </ng-container>
            </dx-data-grid>
        </div>
    </ng-container>
</dx-data-grid>
